import { DE } from './country-codes';

export const salesEmailUS = 'sales@shipstation.com';
export const salesEmailGB = 'sales@shipstation.co.uk';
export const salesEmailCA = 'sales@shipstation.ca';
export const salesEmailAU = 'sales@shipstation.com.au';
export const salesEmailFR = 'sales@shipstation.fr';
export const salesEmailNZ = 'sales@shipstation.co.nz';

export const salesEmails = {
  US: salesEmailUS,
  GB: salesEmailGB,
  CA: salesEmailCA,
  AU: salesEmailAU,
  NZ: salesEmailNZ,
  FR: salesEmailFR,
};

export const getSalesEmail = (countryCode) => {
  if (countryCode === DE) {
    return salesEmailGB;
  }
  return salesEmails[countryCode] ?? salesEmailUS;
};
